import { KIND_FILTERS, type KindFilter, RIGHT_PANE_MODES, type RightPaneMode } from '../types';

export const parseKindParam = (raw: string | null): KindFilter =>
  KIND_FILTERS.includes(raw as KindFilter) ? (raw as KindFilter) : 'all';

export const parsePaneParam = (raw: string | null): RightPaneMode | null =>
  RIGHT_PANE_MODES.includes(raw as RightPaneMode) ? (raw as RightPaneMode) : null;

export const parseIdParam = (raw: string | null): string | null => {
  const trimmed = raw?.trim();
  return trimmed ? trimmed : null;
};
